/*
 *
 * AlertDialog constants
 *
 */

export const OPEN_ALERT_DIALOG = 'claris-vnext/AlertDialog/OPEN_ALERT_DIALOG';
export const CLOSE_ALERT_DIALOG = 'claris-vnext/AlertDialog/CLOSE_ALERT_DIALOG';
export const CONFIRM_ALERT_DIALOG = 'claris-vnext/AlertDialog/CONFIRM_ALERT_DIALOG';
